export default __webpack_public_path__ + "static/icon-andy-signature--mobile-cfed820cf1078c2f8df3978393308e34.webp";